import Grid from "@mui/material/Grid";
import React from "react";
import PageGridPlacement from "../layouts/body/PageGridPlacement";
import P011Publication from "../doctypes/P011Publication/P011Publication";
import P015Cart from "../doctypes/cart/P015Cart";
import dynamic from "next/dynamic";
import {PageGridPlacementType} from "../types";
import {isWimmelbild, pageGridContainerSx, pageGridItemSx} from "./pageLayoutsUtils";

import type { CAEGlobalSettings } from "../../types/CAEGlobalSettings";

interface Props {
    navigation: any,
    page: any,
    content?: any,
    CAEGlobalSettings: CAEGlobalSettings,
    children?: JSX.Element,
    currentURL: string,
    csrfToken: string,
    credentials: any,
    donationInitializerData?: { queryData: any; isProduct: boolean; contentId: string } | null
}
const P010Wimmelbild = dynamic(() => import('../doctypes/P010Wimmelbild'), {
    ssr: false,
});


function BlankPageLayout(props: Props) {
    const isPublication = props.content?.content?.content?.type === "SOSPublication"
    const isCart = props.currentURL.endsWith("warenkorb")
    return (
        <>
            <Grid
                container
                spacing={1}
                sx={pageGridContainerSx}>
                <Grid component='main' sx={pageGridItemSx}>
                    {props.page && isWimmelbild(props.page) ? <P010Wimmelbild wimmelbild={props.page}/> : ""}
                    {isPublication ?
                        <P011Publication sosPublication={props.content.content?.content}
                                         backUri={props.page?.selfUrl}/> : ''}
                    {isCart ?
                        <P015Cart/> : ""}
                    {
                        props.page.grid.placements.map((p: PageGridPlacementType, index: number) => renderPlacements(p, index, props.CAEGlobalSettings, props.csrfToken, props.credentials, props.donationInitializerData))
                    }
                </Grid>
            </Grid>
        </>
    );
}

function renderPlacements(placement: PageGridPlacementType, index: number, CAEGlobalSettings: CAEGlobalSettings, csrfToken: string, credentials: any, donationInitializerData?: { queryData: any; isProduct: boolean; contentId: string } | null) {
    switch (placement.name) {
        case "header": {
            return null
        }
        case "footer": {
            return null
        }
        default: {
            return <PageGridPlacement placementName={placement.name} key={index} items={placement.items} viewtype={placement.viewtype || ''}
                                      CAEGlobalSettings={CAEGlobalSettings} csrfToken={csrfToken} credentials={credentials}
                                      donationInitializerData={donationInitializerData}/>
        }
    }
}

export default BlankPageLayout